export function farloUiExperienceCarousel(element) {
    let flkty = "";
    if (window.innerWidth <= 980) {
        flkty = new Flickity(element, {
            cellAlign: 'left',
            pageDots: true,
            prevNextButtons: true,
            wrapAround: true,
            groupCells: false,
            freeScroll: false,
            draggable: true,
            dragThreshold: 1,
        });
    } else {
        flkty = new Flickity(element, {
            cellAlign: 'left',
            pageDots: true,
            prevNextButtons: true,
            wrapAround: false,
            groupCells: false,
            freeScroll: false,
            draggable: true,
            dragThreshold: 1,
        });
    }

    // Handle window resizing
    const onResize = () => {
        if (window.innerWidth <= 980) {
            flkty.destroy();
            flkty = new Flickity(element, {
                cellAlign: 'left',
                pageDots: true,
                prevNextButtons: true,
                wrapAround: false,
                groupCells: false,
                freeScroll: false,
                draggable: true,
                dragThreshold: 1,
            });
        } else if (flkty != "") {
            flkty.destroy();
            flkty = new Flickity(element, {
                cellAlign: 'left',
                pageDots: true,
                prevNextButtons: true,
                wrapAround: false,
                groupCells: false,
                freeScroll: false,
                draggable: true,
                dragThreshold: 1,
            });

        }

    };

    // Horizontal scrolling with mouse wheel, but allow vertical scrolling
    const onWheel = (event) => {
        // Check if the horizontal scroll delta (event.deltaX) is significant
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
            // Prevent default scroll only when scrolling horizontally
            event.preventDefault();
            
            if (event.deltaX < 0) {
                flkty.previous();  // Scroll left (back)
            } else if (event.deltaX > 0) {
                flkty.next();  // Scroll right (forward)
            }
        }
    };

    // Add touch handling for mobile devices
    let startX, startY;

    const onTouchStart = (event) => {
        const touch = event.touches[0];
        startX = touch.pageX;
        startY = touch.pageY;
    };

    const onTouchMove = (event) => {
        const touch = event.touches[0];
        const deltaX = touch.pageX - startX;
        const deltaY = touch.pageY - startY;

        // Check if horizontal movement is larger than vertical movement
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
            // Prevent vertical scrolling if it's a horizontal swipe
            event.preventDefault();
            // Move Flickity horizontally based on swipe
            if (deltaX < 0) {
                flkty.next();  // Swipe left to scroll right
            } else {
                flkty.previous();  // Swipe right to scroll left
            }
        }
        // Otherwise, let vertical scrolling proceed as normal
    };

    element.addEventListener('wheel', onWheel);
    element.addEventListener('touchstart', onTouchStart);
    element.addEventListener('touchmove', onTouchMove);

    window.addEventListener('resize', onResize);
}